import { IGameAnswer } from '../../data/question'
import chartValues from './chartValues'

const buildLabelsArray = (answers: Array<IGameAnswer>, areAnswersHidden: boolean) => {
	let baseLabelArray
	if (areAnswersHidden) {
		baseLabelArray = [...chartValues.hiddenAnswersLabels]
	} else {
		baseLabelArray = answers.map((answer: IGameAnswer, index: number) => {
			if (answer.correct) {
				return `${chartValues.correctPrefix}${chartValues.possibleLabels[index]}`
			} else {
				return chartValues.possibleLabels[index]
			}
		})
	}

	baseLabelArray.push(chartValues.noneAnswerLabel)
	// The label array always has the same number of elements as the possible labels array,
	// it allows us to maintain the correct size of the chart bars.
	while (baseLabelArray.length < chartValues.possibleLabels.length + 1) {
		baseLabelArray.push('')
	}

	return baseLabelArray
}

export default buildLabelsArray
